/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASEUtils from "../../utils/BASEUtils";
import AppContext from "../../../app/AppContext";
import { Component } from "react";
import { matchRoutes } from "react-router-dom";
import withRouter from "../withRouter";
import history from "../../../@history";

let loginRedirectUrl = null;

class BASEAuthorization extends Component {
  constructor(props, context) {
    super(props);
    const { routes } = context;
    this.state = {
      accessGranted: true,
      routes,
    };
    this.defaultLoginRedirectUrl = props.loginRedirectUrl || "/";
  }

  componentDidMount() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.accessGranted !== this.state.accessGranted;
  }

  componentDidUpdate() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  // static getDerivedStateFromProps(props, state) {
  //   const { location, userRole } = props;
  //   const { pathname } = location;

  //   const matchedRoutes = matchRoutes(state.routes, pathname);

  //   const matched = matchedRoutes ? matchedRoutes[0] : false;
  //   return {
  //     accessGranted: matched
  //       ? BASEUtils.hasPermission(matched.route.auth, userRole)
  //       : true,
  //   };
  // }

  static getDerivedStateFromProps(props, state) {
    const { location, userRole } = props;
    const { pathname } = location;

    const matchedRoutes = matchRoutes(state.routes, pathname);

    if (!matchedRoutes || matchedRoutes.length === 0) {
      return { accessGranted: true };
    }

    // Find the deepest route with an `auth` property
    const deepestWithAuth = [...matchedRoutes].reverse().find(r => r.route.auth !== undefined);

    return {
      accessGranted: deepestWithAuth
        ? BASEUtils.hasPermission(deepestWithAuth.route.auth, userRole)
        : true,
    };
  }

  redirectRoute() {
    const { location, userRole } = this.props;
    const { pathname } = location;
    const redirectUrl = loginRedirectUrl || this.defaultLoginRedirectUrl;

    /*
        User is guest
        Redirect to Login Page
        */
    if (!userRole || userRole.length === 0) {
      setTimeout(() => history.push("/sign-in"), 0);
      loginRedirectUrl = pathname;
    } else {
      /*
        User is member
        User must be on unAuthorized page or just logged in
        Redirect to dashboard or loginRedirectUrl
        */
      setTimeout(() => history.push(redirectUrl), 0);
      loginRedirectUrl = this.defaultLoginRedirectUrl;
    }
  }

  render() {
    // console.info('BASE Authorization rendered', this.state.accessGranted);
    return this.state.accessGranted ? <>{this.props.children}</> : null;
  }
}

BASEAuthorization.contextType = AppContext;

export default withRouter(BASEAuthorization);
